import { render } from "./PlanilhaTrechos.vue?vue&type=template&id=78fbc744"
import script from "./PlanilhaTrechos.vue?vue&type=script&lang=ts"
export * from "./PlanilhaTrechos.vue?vue&type=script&lang=ts"
script.render = render

export default script